import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/common/Reveal";
import { CourseArt } from "@/components/common/CourseArt";

export const CourseCard = ({ course, index = 0 }) => {
  return (
    <Reveal delay={index * 0.08} as="article" className="h-full">
      <Link
        to={`/courses#${course.slug}`}
        className="group flex h-full flex-col card-soft overflow-hidden transition-[transform,box-shadow] duration-300 hover:-translate-y-1.5 hover:shadow-lift"
        data-testid={`course-card-${course.slug}`}
      >
        <div className={`relative ${course.color} h-44 overflow-hidden`}>
          <CourseArt name={course.slug} className="absolute inset-0 h-full w-full p-4 transition-transform duration-500 group-hover:scale-105" />
        </div>
        <div className="flex flex-1 flex-col p-7">
          {course.pbl && <span className="mb-3 w-fit rounded-full border border-ink/20 bg-cream px-3 py-1 text-xs font-bold uppercase tracking-wider">Project-based learning</span>}
          <h3 className="text-2xl font-semibold">{course.title}</h3>
          <p className="mt-3 flex-1 text-ink-soft leading-relaxed">{course.short}</p>
          <span className="mt-6 inline-flex items-center gap-1.5 font-bold">
            Explore course
            <ArrowUpRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
          </span>
        </div>
      </Link>
    </Reveal>
  );
};
